import { Stack } from '@mui/material';
import styled from 'styled-components';

export const ErrorContainer = styled(Stack)`
  && {
    background-color: ${({ theme }) => theme.palette.background.paper};
    border-radius: ${({ theme }) => theme.shape.cardRadius};
    padding: 2.5rem;
    width: 400px;
  }
`;
